import { action } from 'satcheljs';

export default action('SELECT_SEARCH_TOP_RESULTS_OPTION', (shouldHideTopResults: boolean) => ({
    shouldHideTopResults,
}));
